import digCapture from 'gleam-shared/domain/digCapture'

const SHOW_EVENT = 'show'

export default function whenCaptureShows(key) {
  const capture = digCapture(key)

  if (!capture) {
    return Promise.reject(new Error(`${key} failed to initialize!`))
  }

  if (capture.showing) {
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    capture.on(SHOW_EVENT, onShow)

    function onShow() {
      capture.off(SHOW_EVENT, onShow)
      resolve(capture)
    }
  })
}
